import { config, server } from "..";

export const updateProfile = (data: any) => {
  return server.patch("/profile", data, config);
};

export const getProfile = () => {
  return server.get("/profile", config);
};

export const updatePiProfile = (piApiKey: string) => {
  return server.post("/setup-pi-data", { piApiKey }, config);
};

export const updateLocation = (data: { lat: number; long: number }) => {
  return server.patch("/users/location", data, config);
};
